<template lang="html">
    <nav class="nav">
        <div class="flex align-center logos-nav"> <router-link class="logo-ajusa" :to="$t('enlaces.home')"></router-link>
            <router-link class="logo-historia" :to="$t('enlaces.aniversario50')"></router-link>
        </div>
        <idioma :show="true"></idioma>
        <div class="hamburger" @click="toggleMenu">
            <button class="icon-menu">
                <span></span>
                <span></span>
                <span></span>
            </button>
        </div>
        <div class="flex align-center options-nav">
            <dropdown :id="option" :option="option" :show_dropdown="show_dropdown" v-for="(option, key) in options" :key="key"></dropdown>
            <lang-selector></lang-selector>
        </div>
    </nav>
</template>

<script lang="js">
import Dropdown from '@/components/parts/dropdown';
import Languages from '@/components/parts/lang-selector'
import Idioma from '@/components/view-parts/footer-parts/idioma'

export default {
    name: 'navbar',
    props: [],
    components: {
        'dropdown': Dropdown,
        'lang-selector': Languages,
        'idioma': Idioma
    },
    data() {
        return {
            'options': [
                'productos',
                'catalogo',
                'area_tecnica',
                'sobre_nosotros'
            ],
            show_dropdown: false,
        }
    },
    methods: {
      toggleMenu: function () {
        this.show_dropdown = !this.show_dropdown;
      }
    },
    watch: {
        '$route': function () {
            this.show_dropdown = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/navbar.vue